import { render } from "./box_shadow.vue?vue&type=template&id=54e5e7b2"
import script from "./box_shadow.vue?vue&type=script&lang=js"
export * from "./box_shadow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__